import { ActivatedRoute, Router } from '@angular/router';

import { Injectable } from '@angular/core';

@Injectable()
export class BreadcrumbService {
  private labels: Map<string, string>;

  constructor(private router: Router) {
    this.labels = new Map<string, string>();
  }

  public buildUrl(route: ActivatedRoute): string {
    let url = '';
    route.pathFromRoot.forEach((parentRoute: ActivatedRoute) => {
      if (parentRoute.snapshot.url.length > 0) {
        url += '/' + parentRoute.snapshot.url.map(segment => segment.path).join('/');
      }
    });
    if (url === '/t' || url === '/tm') {
      url = '/q';
    }
    return url;
  }

  public addLabel(route: ActivatedRoute, label: string) {
    this.labels.set(this.buildUrl(route), label);
  }

  public getLabel(route: ActivatedRoute): string {
    let label = this.labels.get(this.buildUrl(route));
    if (!label) {
      //   // tslint:disable:no-string-literal
      label = route.snapshot.data['title'];
    }
    return label;
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/breadcrumb/breadcrumb.service.ts